import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material";
import { configuration } from "src/environments/environment";
import { LoginModelComponent } from "./login-model/login-model.component";

@Component({
    selector: 'app-autoLOgoffComponent',
    template: ''
})
export class AutoLogoffComponent implements OnInit {
    MINUTES_UNITL_AUTO_LOGOUT = 1 // in mins
    CHECK_INTERVAL = 5 // in ms
    STORE_KEY = 'AutoLogoff_lastAction';
    AutoLogOffInterval;
    ISONCEnabled: boolean = configuration.ISONCEnabled
    constructor(private dialog: MatDialog) { }
    ngOnInit(): void {
        localStorage.removeItem(this.STORE_KEY);
        if (this.ISONCEnabled == true) {
            if (sessionStorage.getItem('ApplicationLockTime'))
                this.MINUTES_UNITL_AUTO_LOGOUT = Number(sessionStorage.getItem('ApplicationLockTime'))
            this.check();
            this.initListener();
            this.initInterval();
            localStorage.setItem(this.STORE_KEY, Date.now().toString());
        }
    }
    public getLastAction() {
        return parseInt(localStorage.getItem(this.STORE_KEY));
    }
    public setLastAction(lastAction: number) {
        localStorage.setItem(this.STORE_KEY, lastAction.toString());
    }

    initListener() {
        document.body.addEventListener('click', () => this.reset());
        document.body.addEventListener('mouseover', () => this.reset());
        document.body.addEventListener('mouseout', () => this.reset());
        document.body.addEventListener('keydown', () => this.reset());
        document.body.addEventListener('keyup', () => this.reset());
        document.body.addEventListener('keypress', () => this.reset());
    }

    reset() {
        this.setLastAction(Date.now());
    }

    initInterval() {
        this.AutoLogOffInterval = setInterval(() => {
            this.check();
        }, this.CHECK_INTERVAL);
    }

    check() {
        if (sessionStorage.getItem("userId")) {
            const now = Date.now();
            const timeleft = this.getLastAction() + this.MINUTES_UNITL_AUTO_LOGOUT * 60 * 1000;
            const diff = timeleft - now;
            const isTimeout = diff < 0;

            if (isTimeout) {
                clearInterval(this.AutoLogOffInterval);
                localStorage.removeItem(this.STORE_KEY);
                //localStorage.clear();
                //  alert('Auto logoff')
                this.openDialog();

                // this.router.navigate(['./login']);
            }
        }
    }
    openDialog(): void {
        const dialogRef = this.dialog.open(LoginModelComponent, {
            disableClose: true
            // width: '800px',
            // height: '500px'
            // data: {name: this.name, animal: this.animal},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result == "success" || result == "logout") {
                this.reset();
            }
            else
                this.openDialog();

        });
    }
}

